import React, { useMemo } from 'react';
import { Row, Col } from 'antd';
import CustomButton from '../../../../../../../../../v2-components/Antd/Button';
import CustomSelect from '../../../../../../../../../v2-components/Antd/Select';
import CustomInputNumber from '../../../../../../../../../v2-components/Antd/InputNumber';
import './style.scss';

export default function Step3DeliveryDatePrice({
  deliveryType,
  deliveryDate,
  deliveryDates = [],
  originalPrice,
  finalPrice,
  shippingCost,
  subTotalAmount,
  totalAmount,
  selectedProducts,
  productQuantities,
  onDeliveryDateChange,
  onFinalPriceChange,
  onBack,
  onNext,
  isLoading = false,
}) {
  const isDelivery = deliveryType === 'delivery';

  // Calculate subtotal from selected products
  const subtotal = useMemo(() => {
    return selectedProducts.reduce((acc, product) => {
      const qty = productQuantities[product.id] || product.quantity;
      return acc + (product.unitPrice * qty);
    }, 0);
  }, [selectedProducts, productQuantities]);

  // Calculate total dynamically based on finalPrice + shippingCost
  const total = useMemo(() => {
    const price = finalPrice || subtotal;
    return isDelivery ? price + (shippingCost || 0) : price;
  }, [finalPrice, subtotal, shippingCost, isDelivery]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0,
    }).format(price || 0);
  };

  const handleFinalPriceChange = (value) => {
    onFinalPriceChange(value || 0);
  };

  const canContinue = isDelivery ? !!deliveryDate : true;

  return (
    <div className="step-delivery-date-price">
      <div className="step-header">
        <h2>Finalizar compra</h2>
        <p className="step-subtitle">
          {isDelivery ? 'Seleccionar día de entrega' : 'Confirmación de precios'}
        </p>
      </div>

      {isDelivery && (
        <div className="delivery-date-section">
          <div className="form-field">
            <label>Día de entrega</label>
            <CustomSelect
              value={deliveryDate}
              onChange={onDeliveryDateChange}
              options={deliveryDates}
              loading={isLoading}
              placeholder="Seleccionar día de entrega"
              style={{ width: '100%' }}
            />
          </div>
        </div>
      )}

      <div className="price-section">
        <h3 className="price-title">Precio</h3>
        
        <Row gutter={24}>
          <Col span={12}>
            <div className="price-field">
              <label>Precio inicial de los productos</label>
              <CustomInputNumber
                value={originalPrice}
                disabled
                style={{ width: '100%' }}
                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                parser={value => value.replace(/\$\s?|(\.)/g, '')}
              />
            </div>
          </Col>
          <Col span={12}>
            <div className="price-field">
              <label>Precio final productos</label>
              <CustomInputNumber
                value={finalPrice}
                onChange={handleFinalPriceChange}
                min={0}
                style={{ width: '100%' }}
                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                parser={value => value.replace(/\$\s?|(\.)/g, '')}
              />
            </div>
          </Col>
        </Row>

        <div className="price-summary">
          <div className="summary-row">
            <span className="summary-label">Sub-total productos:</span>
            <span className="summary-value">{formatPrice(finalPrice || subtotal)}</span>
          </div>
          
          {isDelivery && (
            <div className="summary-row">
              <span className="summary-label">Costo de envío:</span>
              <span className="summary-value">{formatPrice(shippingCost)}</span>
            </div>
          )}
          
          <div className="summary-row total">
            <span className="summary-label">Total:</span>
            <span className="summary-value">{formatPrice(total)}</span>
          </div>
        </div>
      </div>

      <div className="step-footer">
        <CustomButton onClick={onBack} className="btn-back">
          Volver
        </CustomButton>
        <CustomButton
          type="primary"
          onClick={onNext}
          disabled={!canContinue}
          className="btn-continue"
        >
          Continuar
        </CustomButton>
      </div>
    </div>
  );
}
